import React from 'react';
import Modal from "react-bootstrap/Modal";
import DataTable from '../../common/DataTable';
import { TransactionLevelView } from '../../../constant';
import PropTypes from 'prop-types';

const RentInvoice = (props) => {
    const { showModal, handleClose } = props;
    const ListData = [
        { item: 'Hand Sanitizer (Small)', weight: '200 ml', volume: '0.0086', size: 'S', quantity: '1000', rate: '$100' },
        { item: 'Hand Sanitizer (Large)', weight: '500 ml', volume: '0.1086', size: 'M', quantity: '700', rate: '$400' },
        { item: 'Dell Laptops', weight: '500 gm', volume: '186', size: '-', quantity: '75', rate: '$2700' },
        { item: 'Mobile', weight: '7500 gm', volume: '186', size: '-', quantity: '175', rate: '$55' },

    ];
    return (
        <Modal
            {...props}
            size="lg"
            className="topUpModal"
            centered
            backdrop="static"
            show={showModal}
        >
            <div className="top_modal_header_container">
                <span className="">Transaction Level View</span>
                <div className="modalDeleteWrapper">
                    <button
                        type="button"
                        onClick={() => handleClose()}
                        className="btn-close"
                        aria-label="Close"
                    ></button>
                </div>
            </div>
            <div className="modal_container_rate_card">
                <div className="main_content cus-page-content-sec srch-pt0 zIndex1">
                    <div className="main_content_table_history">
                        <div className="incomingTbl">
                            <DataTable
                                headers={TransactionLevelView}
                                tableData={ListData}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
}

RentInvoice.propTypes = {
    showModal: PropTypes.bool,
    handleClose: PropTypes.func
};

export default RentInvoice;